import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Pin = (props: SVGIcon) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 24">
    <path d="M8.352 0C3.747 0 0 3.747 0 8.352c0 1.556.431 3.074 1.247 4.392l6.63 10.684c.127.204.35.329.591.329h.005c.243-.002.467-.13.592-.339l6.461-10.787c.77-1.29 1.178-2.77 1.178-4.279C16.704 3.747 12.957 0 8.352 0zm5.98 11.916l-5.875 9.808L2.43 12.01c-.68-1.096-1.047-2.361-1.047-3.658 0-3.838 3.131-6.97 6.969-6.97 3.838 0 6.965 3.132 6.965 6.97 0 1.258-.344 2.491-.986 3.564z" />
    <path
      fillRule="nonzero"
      d="M8.352 4.176c-2.303 0-4.176 1.873-4.176 4.176 0 2.288 1.843 4.176 4.176 4.176 2.362 0 4.176-1.913 4.176-4.176 0-2.303-1.873-4.176-4.176-4.176zm0 6.97c-1.543 0-2.793-1.255-2.793-2.794 0-1.535 1.258-2.793 2.793-2.793 1.535 0 2.789 1.258 2.789 2.793 0 1.516-1.221 2.793-2.789 2.793z"
    />
  </svg>
)
